import { PropsWithChildren } from "react";
import ListCheckBoxGroup from "./list-check-box-group";
import CollapseCheckBoxGroup from "./collapse-check-box-group";
import { CheckBoxGroupGroupProvider } from "./check-box-group-context";
import { CheckBoxProps } from "@/components/inputs";

export type FormCheckBoxGroupProps = CheckBoxProps & PropsWithChildren & {
    variant?: "list" | "collapse"
}

export default function FormCheckBoxGroup({
    children,
    variant = "list",
    ...props
}: FormCheckBoxGroupProps) {
    const handleRenderContent = () => {
        if (variant === "list") {
            return <ListCheckBoxGroup {...props}>
                {children}
            </ListCheckBoxGroup>
        } else {
            return <CollapseCheckBoxGroup {...props}>
                {children}
            </CollapseCheckBoxGroup>
        }
    }

    return <CheckBoxGroupGroupProvider variant={variant}>
        {handleRenderContent()}
    </CheckBoxGroupGroupProvider>
}